module.exports = __webpack_public_path__ + "img/Avatar-2.23aa9551.webp";